import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalService } from 'src/app/services/modal/modal.service';
import { environment } from 'src/environments/environment';

export interface CguDecision {
  isAccepted: boolean;
}

@Component({
  selector: 'app-handle-cgu',
  templateUrl: './handle-cgu.component.html',
  styleUrls: [
    './handle-cgu.component.scss',
    '../modal.fragment.scss'
  ]
})
export class HandleCguComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  @Output() public closeEmitter = new EventEmitter<CguDecision>();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }
  public isLoading = false;

  public set cguContentSetter(value: string) {
    this.cguPdf = this._domSanitizer.bypassSecurityTrustResourceUrl(value);
  }
  public cguPdf: SafeResourceUrl;

  constructor (
    private _domSanitizer: DomSanitizer,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
  ) { }

  ngOnInit(): void {
  }

  public closeModal(decision?: CguDecision): void {
    this.closeEmitter.emit(decision);
  }

  public async acceptCgu(): Promise<void> {
    try {
      this.closeModal({ isAccepted: true });
    } catch (e) {
      this._modalSrv.openAlert(
        this._viewContainerRef, 'Erreur', `Une erreur s'est produite lors de l'acceptation des CGU.`
      );
    }
  }
  
  public async refuseCgu(): Promise<void> {
    try {
      this.closeModal({ isAccepted: false });
    } catch (e) {
      this._modalSrv.openAlert(
        this._viewContainerRef, 'Erreur', `Une erreur s'est produite lors du refus des CGU.`
      );
    }
  }

}
